import bridge from '@vkontakte/vk-bridge';
import {loadScrollPosition, saveScrollPosition} from "./utils";
// import {store} from "../store";

export function manageScrollPosition(store, type) {
    let activePanel = store.state.activePanel;

    if (type === 'load') {
        loadScrollPosition(activePanel);
    }

    if (type === 'save') {
        saveScrollPosition(activePanel);
    }
}

export function managePanels(that, event) {
    console.log(event);
    const decrementHistoryDepth = function () {
        let depth = that.$store.state.historyDepth - 1;
        that.$store.commit('setHistoryDepth', depth);
    };

    switch (that.$store.state.activePanel) {
        case "moon-category-info":
            that.$store.commit('setActivePanel', 'home');
            that.$store.commit('setLastActivePanel', 'moon-category-info');
            decrementHistoryDepth();

            break;
        case "horoscope-sign":
            that.$store.commit('setActivePanel', 'horoscope');
            that.$store.commit('setLastActivePanel', 'horoscope-sign');
            decrementHistoryDepth();

            break;
        case "horoscope":
            that.$store.commit('setActivePanel', 'home');
            that.$store.commit('setLastActivePanel', 'horoscope');
            decrementHistoryDepth();

            break;
        case "origin":
            that.$store.commit('setActivePanel', 'home');
            that.$store.commit('setLastActivePanel', 'origin');
            decrementHistoryDepth();

            break;
        case 'home':
            that.$store.commit('setActivePanel', 'home');
            that.$store.commit('setLastActivePanel', '');
            bridge.send("VKWebAppClose", {"status": "success"});

            break;
    }
}
